import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import {
  FormElement,
  FormList,
  FormListItem,
} from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { Confirmation } from '../../modals/common';
import { HOT_WORKCODE, SYSTEM_WORK_TIME } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

const HotWorkTemplate = ({
  context,
  grid,
  handlePushParam,
  column,
  tabKeyStatus,
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const [hotWorkCode, setHotWorkCode] = useState('');
  const [workStart, setWorkStart] = useState('');
  const [workEnd, setWorkEnd] = useState('');
  const { isAbortedOrApproved } = context.item;

  const handleSetData = () => {
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem['hot_work_code'] = hotWorkCode;
    v.currentItem['hot_work_end'] = workEnd;
    v.currentItem['hot_work_start'] = workStart;
    if (!v.currentItem['is_data_changed']['hot_work']) {
      v.currentItem['is_data_changed']['hot_work'] = true;
    }
    v.commitEdit();
    handlePushParam(context.item);
    setShowDialog(false);
  };

  const renderContent = () => (
    <FormList>
      <FormListItem label='種別'>
        <FormElement>
          <select
            value={hotWorkCode}
            onChange={e => setHotWorkCode(e.target.value)}
          >
            <option value=''>---</option>
            {_.map(HOT_WORKCODE, workCode => (
              <option key={workCode.id} value={workCode.id}>
                {workCode.name}
              </option>
            ))}
          </select>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </FormElement>
      </FormListItem>
      <FormListItem label='使用時間'>
        <FormElement>
          <div className='input-date-range'>
            <WorkTime
              setValue={setWorkStart}
              value={workStart}
              keyName={`time-start${context.item.id}`}
            />
            <span className='input-date-range__bar'>〜</span>
            <WorkTime
              setValue={setWorkEnd}
              value={workEnd}
              keyName={`time-end${context.item.id}`}
            />
          </div>
        </FormElement>
      </FormListItem>
    </FormList>
  );

  useEffect(() => {
    setWorkStart(_.get(context, 'item.hot_work_start') || '');
    setWorkEnd(_.get(context, 'item.hot_work_end') || '');
    setHotWorkCode(_.get(context, 'item.hot_work_code') || '');
  }, [showDialog]);

  return (
    <CellContent
      isDataChanged={_.get(context, `item.is_data_changed.hot_work`)}
      key={`${column}_${_.get(context, 'item.id')}`}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
    >
      <button
        className={[
          isAbortedOrApproved ? 'btn-fixedsize--disabled' : '',
          'btn-fixedsize--sub btn-dialog',
        ].join(' ')}
        onClick={() => {
          setShowDialog(true);
        }}
        tabIndex={tabKeyStatus}
      >
        火気を変更
      </button>
      <Confirmation
        visible={showDialog}
        title='火気'
        negativeButtonClassName={'btn--effective'}
        message={renderContent()}
        confirmButtonText='保存'
        cancelButtonText={messageUtility.getMessage('I-000-017')}
        onCancel={() => setShowDialog(false)}
        onConfirm={handleSetData}
        rootClassName='dialog--wide HotWorkModal'
      />
    </CellContent>
  );
};

const WorkTime = ({ value, setValue, keyName }) => {
  return (
    <React.Fragment>
      <select
        value={value}
        onChange={e => setValue(e.target.value)}
        key={keyName}
      >
        <option value=''>---</option>
        {_.map(SYSTEM_WORK_TIME, workTime => (
          <option key={workTime.id} value={workTime.normal}>
            {workTime.name}
          </option>
        ))}
      </select>
      <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
    </React.Fragment>
  );
};

export default HotWorkTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/HotWorkTemplate.jsx